import {SpecialOfferCompactList} from "App/services/api";
import {FetchAction, FetchState} from "App/services";
import {ActionType} from "App/constants";

export {SpecialOfferCompactList as State};

export function reducer(state: SpecialOfferCompactList = [], action: FetchAction) {
    switch (action.state) {
        case FetchState.SUCCESS: {
            switch (action.type) {
                case ActionType.FETCH_SPECIALOFFERSCOMPACTOVERVIEW: {
                    return action.payload
                }
                default:
                    return state;
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/specialoffers.ts